<main role="main">
  <div class="p-3 auth-container col-12 h-100">
    <router-outlet></router-outlet>
  </div>
</main>
